"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wyb = exports.wvsb = exports.wvnb = exports.wieb = exports.wiwb = exports.wawb = exports.waeb = exports.vtb = exports.vib = exports.vawb = exports.vaeb = exports.utb = exports.txnb = exports.txsb = exports.txwb = exports.txeb = exports.tnmb = exports.tnwb = exports.tneb = exports.sdb = exports.scb = exports.rib = exports.prb = exports.paeb = exports.pawb = exports.pamb = exports.orb = exports.oknb = exports.okwb = exports.okeb = exports.ohnb = exports.ohsb = exports.nyeb = exports.nysb = exports.nywb = exports.nynb = exports.nvb = exports.nmb = exports.njb = exports.nhb = exports.neb = exports.ndb = exports.ncwb = exports.ncmb = exports.nceb = exports.mpb = exports.mtb = exports.msnb = exports.mssb = exports.mowb = exports.moeb = exports.mnb = exports.miwb = exports.mieb = exports.meb = exports.mdb = exports.mab = exports.lawb = exports.lamb = exports.laeb = exports.kywb = exports.kyeb = exports.ksb = exports.ianb = exports.iasb = exports.insb = exports.innb = exports.ilnb = exports.ilsb = exports.ilcb = exports.idb = exports.hib = exports.gub = exports.ganb = exports.gamb = exports.gasb = exports.flsb = exports.flmb = exports.flnb = exports.deb = exports.dcb = exports.ctb = exports.cob = exports.cacb = exports.casb = exports.caeb = exports.canb = exports.azb = exports.arwb = exports.areb = exports.alnb = exports.alsb = exports.almb = exports.akb = void 0;
var akb = 'District of Alaska';
exports.akb = akb;
var almb = 'Middle District of Alabama';
exports.almb = almb;
var alsb = 'Southern District of Alabama';
exports.alsb = alsb;
var alnb = 'Northern District of Alabama';
exports.alnb = alnb;
var areb = 'Eastern District of Arkansas';
exports.areb = areb;
var arwb = 'Western District of Arkansas';
exports.arwb = arwb;
var azb = 'District of Arizona';
exports.azb = azb;
var canb = 'Northern District of California';
exports.canb = canb;
var caeb = 'Eastern District of California';
exports.caeb = caeb;
var casb = 'Southern District of California';
exports.casb = casb;
var cacb = 'Central District of California';
exports.cacb = cacb;
var cob = 'District of Colorado';
exports.cob = cob;
var ctb = 'District of Connecticut';
exports.ctb = ctb;
var dcb = 'District of Columbia';
exports.dcb = dcb;
var deb = 'District of Delaware';
exports.deb = deb;
var flnb = 'Northern District of Florida';
exports.flnb = flnb;
var flmb = 'Middle District of Florida';
exports.flmb = flmb;
var flsb = 'Southern District of Florida';
exports.flsb = flsb;
var gasb = 'Southern District of Georgia';
exports.gasb = gasb;
var gamb = 'Middle District of Georgia';
exports.gamb = gamb;
var ganb = 'Northern District of Georgia';
exports.ganb = ganb;
var gub = 'District of Guam';
exports.gub = gub;
var hib = 'District of Hawaii';
exports.hib = hib;
var idb = 'District of Idaho';
exports.idb = idb;
var ilcb = 'Central District of Illinois';
exports.ilcb = ilcb;
var ilsb = 'Southern District of Illinois';
exports.ilsb = ilsb;
var ilnb = 'Northern District of Illinois';
exports.ilnb = ilnb;
var innb = 'Northern District of Indiana';
exports.innb = innb;
var insb = 'Southern District of Indiana';
exports.insb = insb;
var iasb = 'Southern District of Iowa';
exports.iasb = iasb;
var ianb = 'Northern District of Iowa';
exports.ianb = ianb;
var ksb = 'District of Kansas';
exports.ksb = ksb;
var kyeb = 'Eastern District of Kentucky';
exports.kyeb = kyeb;
var kywb = 'Western District of Kentucky';
exports.kywb = kywb;
var laeb = 'Eastern District of Louisiana';
exports.laeb = laeb;
var lamb = 'Middle District of Louisiana';
exports.lamb = lamb;
var lawb = 'Western District of Louisiana';
exports.lawb = lawb;
var mab = 'District of Massachusetts';
exports.mab = mab;
var mdb = 'District of Maryland';
exports.mdb = mdb;
var meb = 'District of Maine';
exports.meb = meb;
var mieb = 'Eastern District of Michigan';
exports.mieb = mieb;
var miwb = 'Western District of Michigan';
exports.miwb = miwb;
var mnb = 'District of Minnesota';
exports.mnb = mnb;
var moeb = 'Eastern District of Missouri';
exports.moeb = moeb;
var mowb = 'Western District of Missouri';
exports.mowb = mowb;
var mssb = 'Southern District of Mississippi';
exports.mssb = mssb;
var msnb = 'Northern District of Mississippi';
exports.msnb = msnb;
var mtb = 'District of Montana';
exports.mtb = mtb;
var mpb = 'District of Northern Mariana Islands';
exports.mpb = mpb;
var nceb = 'Eastern District of North Carolina';
exports.nceb = nceb;
var ncmb = 'Middle District of North Carolina';
exports.ncmb = ncmb;
var ncwb = 'Western District of North Carolina';
exports.ncwb = ncwb;
var ndb = 'District of North Dakota';
exports.ndb = ndb;
var neb = 'District of Nebraska';
exports.neb = neb;
var nhb = 'District of New Hampshire';
exports.nhb = nhb;
var njb = 'District of New Jersey';
exports.njb = njb;
var nmb = 'District of New Mexico';
exports.nmb = nmb;
var nvb = 'District of Nevada';
exports.nvb = nvb;
var nynb = 'Northern District of New York';
exports.nynb = nynb;
var nywb = 'Western District of New York';
exports.nywb = nywb;
var nysb = 'Southern District of New York';
exports.nysb = nysb;
var nyeb = 'Eastern District of New York';
exports.nyeb = nyeb;
var ohsb = 'Southern District of Ohio';
exports.ohsb = ohsb;
var ohnb = 'Northern District of Ohio';
exports.ohnb = ohnb;
var okeb = 'Eastern District of Oklahoma';
exports.okeb = okeb;
var okwb = 'Western District of Oklahoma';
exports.okwb = okwb;
var oknb = 'Northern District of Oklahoma';
exports.oknb = oknb;
var orb = 'District of Oregon';
exports.orb = orb;
var pamb = 'Middle District of Pennsylvania';
exports.pamb = pamb;
var pawb = 'Western District of Pennsylvania';
exports.pawb = pawb;
var paeb = 'Eastern District of Pennsylvania';
exports.paeb = paeb;
var prb = 'District of Puerto Rico';
exports.prb = prb;
var rib = 'District of Rhode Island';
exports.rib = rib;
var scb = 'District of South Carolina';
exports.scb = scb;
var sdb = 'District of South Dakota';
exports.sdb = sdb;
var tneb = 'Eastern District of Tennessee';
exports.tneb = tneb;
var tnwb = 'Western District of Tennessee';
exports.tnwb = tnwb;
var tnmb = 'Middle District of Tennessee';
exports.tnmb = tnmb;
var txeb = 'Eastern District of Texas';
exports.txeb = txeb;
var txwb = 'Western District of Texas';
exports.txwb = txwb;
var txsb = 'Southern District of Texas';
exports.txsb = txsb;
var txnb = 'Northern District of Texas';
exports.txnb = txnb;
var utb = 'District of Utah';
exports.utb = utb;
var vaeb = 'Eastern District of Virginia';
exports.vaeb = vaeb;
var vawb = 'Western District of Virginia';
exports.vawb = vawb;
var vib = 'District of Virgin Islands';
exports.vib = vib;
var vtb = 'District of Vermont';
exports.vtb = vtb;
var waeb = 'Eastern District of Washington';
exports.waeb = waeb;
var wawb = 'Western District of Washington';
exports.wawb = wawb;
var wiwb = 'Western District of Wisconsin';
exports.wiwb = wiwb;
var wieb = 'Eastern District of Wisconsin';
exports.wieb = wieb;
var wvnb = 'Northern District of West Virginia';
exports.wvnb = wvnb;
var wvsb = 'Southern District of West Virginia';
exports.wvsb = wvsb;
var wyb = 'District of Wyoming';
exports.wyb = wyb;